//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productionStatus', {
//        templateUrl: 'views/components/views/productionStatus/productionStatus.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'modalService', 'productionStatusService', function (stateService, utilityService, modalService, productionStatusService) {

//            // #region GLOBAL VARIABLES & DEFINITIONS
            
//            const vm = this;
            
//            vm.model = {
//                barcodeButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.barcode = '' },
//                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('barcode') },
//                    { id: 'search', icon: 'fas fa-search', color: 'success', type: 'success', onClick: () => findItem() }
//                ],
//                barcode: ''
//            };

//            // #endregion GLOBAL VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            function findItem() {
//                if (utilityService.validateParmsValue(vm.model.barcode) !== true) return;

//                productionStatusService.scanItem({ barcode: vm.model.barcode }).then((response) => {
//                    if (response[0]) {
//                        stateService.go(response[0].webpagename, response[0].parms);
//                        clear('barcode');
//                    } else {
//                        clear('barcode');
//                    }
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'barcode':
//                        if (vm.model.barcode > '') {
//                            vm.model.barcode = '';
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            function openCalculator(id) {
//                switch (id) {
//                    case 'barcode':
//                        modalService.showCalculator(vm.model.barcode).then(function (value) {
//                            vm.model.barcode = value;
//                            findItem();
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            // #region SCAN & SEARCH ITEMS

//            vm.searchItem = function () {
//                findItem();
//            }

//            // #endregion SCAN & SEARCH ITEMS

//        }]
//    });
//})();
